<div class="iphone-toggle" [ngClass]="{'disabled': disabled}">
  <input 
    [id]="for"
    type="checkbox"
    class="toggle-input"
    [disabled]="disabled"
    [(ngModel)]="toggle_status"
    (change)="onChange()"
  />
  <label [for]="for" class="toggle-label"></label>
</div>